module.exports = __webpack_public_path__ + "img/icon_service_01.849562b1.png";